import * as ActionTypes from "./actionTypes";

export function loadApps() {
	return { type: ActionTypes.LOAD_APPS };
}

export function loadAppsSuccess(apps) {
	return { type: ActionTypes.LOAD_APPS_SUCCESS, apps };
}

export function loadAppsFail(errorMessage) {
	return { type: ActionTypes.LOAD_APPS_FAIL, errorMessage };
}

export function createApp(name, key) {
	return { type: ActionTypes.CREATE_APP, name, key };
}

export function createAppSuccess(app) {
	return { type: ActionTypes.CREATE_APP_SUCCESS, app };
}

export function createAppFail(error) {
	return { type: ActionTypes.CREATE_APP_FAIL, error };
}

export function editApp(appID, app, callback) {
	return { type: ActionTypes.EDIT_APP, appID, app, callback };
}

export function editAppSuccess() {
	return { type: ActionTypes.EDIT_APP_SUCCESS };
}

export function editAppFail(errorMessage) {
	return { type: ActionTypes.EDIT_APP_FAIL, errorMessage };
}

export function deleteApp(appID) {
	return { type: ActionTypes.DELETE_APP, appID };
}

export function deleteAppSuccess() {
	return { type: ActionTypes.DELETE_APP_SUCCESS };
}

export function deleteAppFail(error) {
	return { type: ActionTypes.DELETE_APP_FAIL, error };
}

export function loadUsers(appID) {
	return { type: ActionTypes.LOAD_USERS, appID };
}

export function loadUsersSuccess(users) {
	return { type: ActionTypes.LOAD_USERS_SUCCESS, users };
}

export function loadUsersFail(errorMessage) {
	return { type: ActionTypes.LOAD_USERS_FAIL, errorMessage };
}

export function editAppNavigation(appKey, navigation, submitHandler) {
	return { type: ActionTypes.EDIT_APP_NAVIGATION, appKey, navigation, submitHandler };
}

export function editAppNavigationSuccess(navigation) {
	return { type: ActionTypes.EDIT_APP_NAVIGATION_SUCCESS, navigation };
}

export function loadAppNavigation(appKey, callback) {
	return { type: ActionTypes.LOAD_APP_NAVIGATION, appKey, callback };
}

export function loadAppNavigationSuccess(navigation) {
	return { type: ActionTypes.LOAD_APP_NAVIGATION_SUCCESS, navigation };
}

export const loadAppConfig = (appKey, callback) => {
	return { type: ActionTypes.LOAD_APP_CONFIG, appKey, callback };
};

export const loadAppConfigSuccess = appConfig => {
	return { type: ActionTypes.LOAD_APP_CONFIG_SUCCESS, appConfig };
};
